import { useFeatureFlagStore } from 'zustand/featureFlag/useFeatureFlagStore';
import { FeatureFlags } from 'zustand/featureFlag/useFeatureFlagStore';
import { useShallow } from 'zustand/react/shallow';
import { useLkpGfpEmailFeatureFlag } from './useLkpGfpEmailFeatureFlag';

const hasLkpGfpAccess = (
  isFeatureLkpGfpEnabled: boolean,
  isEmailEnabled: boolean,
): boolean =>
  isFeatureLkpGfpEnabled ||
  isEmailEnabled;

export default function useLkpGfpAccess() {
  const { isLkpGfpEnabledForEmail } = useLkpGfpEmailFeatureFlag();

  const { isFeatureLkpGfpEnabled, isLoading } = useFeatureFlagStore(
    useShallow((state) => ({
      isFeatureLkpGfpEnabled: state.isFeatureFlagEnabled(
        FeatureFlags.LkpGfpIsEnable,
      ),
      isLoading: state.isLoading,
    })),
  );

  return {
    hasAccess: hasLkpGfpAccess(isFeatureLkpGfpEnabled, isLkpGfpEnabledForEmail),
    isLoading,
    flags: { isFeatureLkpGfpEnabled, isEmailEnabled: isLkpGfpEnabledForEmail },
  };
}
